import React from 'react'

export default function Line2(props) {
    let { className, click } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="8" viewBox="0 0 22 8" fill="none" className={className} onClick={click}>
            <line y1="0.5" x2="22" y2="0.5" stroke="white" />
            <line y1="7.5" x2="15" y2="7.5" stroke="white" />
        </svg>
    )
}
